// extracted by mini-css-extract-plugin
export default {"skipModal":"SkipModal_skipModal__PlsZa","radioGroup":"SkipModal_radioGroup__MZQmo","radioInput":"SkipModal_radioInput__Htebn"};